import React from "react"
import ReactModal from "react-modal"
import {
  Heading2,
  IconImage,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
} from "../../styles"
import closeIcon from "../../icons/close-icon.svg"
import PropTypes from "prop-types"

function Modal({ isOpen, title, onClose, body, allowClose }) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnEsc={allowClose}
      shouldCloseOnOverlayClick={allowClose}
      appElement={document.getElementById("root")}
      ariaHideApp={process.env.NODE_ENV === "test" ? false : true}
    >
      <ModalHeader>
        {title && <Heading2>{title}</Heading2>}
        {allowClose && (
          <ModalCloseButton onClick={onClose} title="Close modal">
            <IconImage src={closeIcon} alt="Close button" />
          </ModalCloseButton>
        )}
      </ModalHeader>
      <ModalBody>{body}</ModalBody>
    </ReactModal>
  )
}

Modal.propTypes = {
  /** If the modal is open or not */
  isOpen: PropTypes.bool,
  /** The title for the modal */
  title: PropTypes.string,
  /** Called on click of close button and on escape/click on overlay */
  onClose: PropTypes.func,
  /** The content of the modal */
  body: PropTypes.node,
  /** Whether to allow the user to close the modal, e.g. with a button, escape key, clicking on overlay */
  allowClose: PropTypes.bool,
}

export default Modal
